export default __webpack_public_path__ + "static/media/falcon.fa3b1ec6.png";